import { render } from "./ContactUs.vue?vue&type=template&id=39566b72&scoped=true&bindings={}"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=39566b72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39566b72"

export default script